import type { Placement } from "tippy.js";

/** A comment on text hangs under its first word; a block is as wide as the article, so its comment is centred. */
const commentPlacement = (hasBlockAnchor: boolean): { placement: Placement; fallbackPlacements: Placement[] } =>
	hasBlockAnchor
		? { placement: "bottom", fallbackPlacements: ["top", "bottom"] }
		: { placement: "bottom-start", fallbackPlacements: ["top-start", "bottom-start"] };

export default commentPlacement;
